import { TextStyle_TextAlignment } from 'ricos-schema';
import { getTextDirection } from 'wix-rich-content-common';

const getTextDirectionFromAlignment = (textAlignment) => textAlignment === TextStyle_TextAlignment.RIGHT ? "rtl" : textAlignment === TextStyle_TextAlignment.LEFT ? "ltr" : void 0;
const getListItemDirection = (textAlignment, text) => {
  const textDirection = ["ltr", "rtl"].includes(getTextDirection(text)) ? getTextDirection(text) : "ltr";
  return getTextDirectionFromAlignment(textAlignment) || textDirection;
};

export { getListItemDirection, getTextDirectionFromAlignment };
//# sourceMappingURL=text-direction.js.map
